import React, {useReducer, useState} from "react";
import * as UserService from "../../api/UserService";
import cabinetStyle from "./MentorCabinet.module.css";
import TrendingFlatIcon from '@mui/icons-material/TrendingFlat';
import Style from "./MentorProfilePagePhotoUpload.module.css";
import noPhoto from "../../image/tmp-png/noPhoto.png"
import {useTranslation} from "react-i18next";

export default function MentorProfilePagePhotoUpload(props) {

    const [photoFile, setPhotoFile] = useState(undefined)
    const [fileUploadError, setFileUploadError] = useState()
    const [uploadInProcess, setUploadInProcess] = useState(false)
    const [_, forceUpdate] = useReducer(x => x + 1, 0);
    const { t } = useTranslation('translation', { keyPrefix: 'mentorProfilePagePhotoUpload' });

    function saveFile() {
        setUploadInProcess(true)
        UserService.getMentorPhotoUploadPresignedUrl(photoFile.name.split(".").slice(-1)[0],
            (awsRequest) => {
                const s3FileUrl = awsRequest.data.url + awsRequest.data.fields.key
                const formData = new FormData();

                for (const key in awsRequest.data.fields) {
                    formData.append(key, awsRequest.data.fields[key]);
                }

                formData.append("file", photoFile)
                fetch(awsRequest.url, {
                    method: "POST",
                    body: formData
                }).then(() => {
                        UserService.saveMentorProfile(
                            null, null, null, s3FileUrl, null,() => {
                                props.pullProfile()
                                setPhotoFile(undefined)
                                forceUpdate()
                            }, () => {
                            }
                        )
                    setUploadInProcess(false)
                    }
                )
                    .catch((e) => {
                        window.alert(e)
                    })
            },
            (error) => {
                setUploadInProcess(false)
                setFileUploadError(error)
            }
        )

    }

    function handlePhotoOnChange(event) {
        const file = event.target.files[0]
        if (file?.size > 550000) {
            setFileUploadError(t('maxFileSize'))
            return
        }
        setPhotoFile(file)
        setFileUploadError(null)
    }

    return <div className={Style.topContainer}>
        <div className={Style.imageContainer}>
            {!props.profile?.photo_url && !photoFile && <img src={noPhoto} style={{height: "200px"}}/>}
            {props.profile?.photo_url && <img src={props.profile.photo_url} style={{height: "200px"}}/>}
            {photoFile && props.profile?.photo_url && <TrendingFlatIcon fontSize={"large"}/>}
            {photoFile && <img src={URL.createObjectURL(photoFile)} style={{height: "200px"}}/>}
            {photoFile === undefined || props.profile?.photo_url === undefined
                && <div className={Style.noPhoto}></div>}
        </div>

        {!props.edit && <>
            <div className={cabinetStyle.uploadPhotoHints}>
                <small>{t('photoValidityCondition1')}</small>
                <small>{t('photoValidityCondition2')}</small>
                <small>{t('photoValidityCondition3')}</small>
            </div>
            {fileUploadError && <text style={{color: "red"}}>{fileUploadError}</text>}
            {!photoFile && <>
                <label htmlFor="upload-photo"
                       className={cabinetStyle.uploadPhotoButton}>{t('download')}{props.profile?.photo_url ? t('new') : " "}{t('photo')}</label>
                <input
                    type="file"
                    accept="image/jpg, image/png, image/jpeg"
                    id={"upload-photo"}
                    name="Photo"
                    onChange={handlePhotoOnChange}
                    style={{display: "none"}}
                />
            </>}
            {photoFile &&
                <div style={{display: "flex", flexDirection: "row", gap: "24px"}}>
                    <button
                        disabled={uploadInProcess}
                        onClick={saveFile}
                        className={cabinetStyle.uploadPhotoButton}>{t('saveButton')}
                    </button>
                    <div
                        className={cabinetStyle.uploadPhotoButton}
                        style={{backgroundColor: "red"}}
                        onClick={() => {
                            setPhotoFile(undefined)
                            setFileUploadError(undefined)
                        }}>{t('cancelButton')}
                    </div>
                </div>
            }

        </>}

    </div>
}
